const NOT_SPECIFIED = 'Not Specified';

export default NOT_SPECIFIED;
